import qs from '../../scripts/util/DOM/qs';
import addClass from '../../scripts/util/DOM/addClass';
import $ from 'jquery';

const selectors = {
	filter: '.js-filter',
	content: '.clients__content',
	box: '.js-filter-box',
	header: '.js-header'
};

const classes = {
	fixed: 'filter_fixed',
	fixedBottom: 'filter_fixed_bottom'
};

const win = window;
const filter = qs(selectors.filter);
const content = qs(selectors.content);

const removeClass = (elem, cls) => {
	elem.classList.remove(cls);
};

const reset = () => {
	removeClass(filter, classes.fixed);
	removeClass(filter, classes.fixedBottom);
};

let scrollVal = 0;
const filterTopPosConst = 150;
let floatDelta = 0;
const headHeight = $(selectors.header).height() + 70; // + 20 for nice padding (= 100px)

const toggleClass = (top, bottom) => {

	if (top <= filterTopPosConst) {
		addClass(classes.fixed)(filter);
		removeClass(filter, classes.fixedBottom);
	} else {
		reset();
		$(selectors.filter).css('top', filterTopPosConst);
	}


	if ( $(selectors.filter).height() + headHeight >= $(window).height() ) { // if filter height more than window height (small screen)

		const scrollValNew = $(window).scrollTop();
		floatDelta = parseInt($(selectors.filter).height() + headHeight - $(window).height(), 10);
		let filterTopPos = parseInt($(selectors.filter).css('top'), 10);

		// console.log(scrollValNew, scrollVal, 'filterTopPosConst:' + filterTopPosConst, 'filterTopPos: ' + filterTopPos, floatDelta);

		if ( scrollVal !== 0 ) {
			if ( scrollValNew >= scrollVal ) { // to bottom
				// console.log(scrollValNew, 'bottom');
				if ( filterTopPos >= filterTopPosConst - floatDelta ) {
					filterTopPos -= ( scrollValNew - scrollVal );
					if ( filterTopPos < filterTopPosConst - floatDelta ) {
						filterTopPos = filterTopPosConst - floatDelta;
					}
				}
			} else if ( filterTopPosConst >= filterTopPos ) {
				filterTopPos += ( scrollVal - scrollValNew );
				if ( filterTopPos > filterTopPosConst ) {
					filterTopPos = filterTopPosConst;
				}
			}


			const aBox = $(selectors.box).offset().top + $(selectors.box).outerHeight();
			const aFil = $(selectors.filter).offset().top + $(selectors.filter).outerHeight();

			// console.log( aBox, aFil );

			// if ( $(selectors.filter)[0].getBoundingClientRect().bottom > $(selectors.box)[0].getBoundingClientRect().bottom ) {
			if ( aFil > aBox ) { // can be upgraded and replaced by logic of "top" position
				removeClass(filter, classes.fixed);
				addClass(classes.fixedBottom)(filter);
			}

		}



		// console.log( $(selectors.filter)[0].getBoundingClientRect().bottom );
		// console.log( $('.clients__content-left')[0].getBoundingClientRect().bottom );


		$(selectors.filter).css('top', filterTopPos);
		scrollVal = scrollValNew;

	} else if ( bottom < 735 ) { // can be upgraded and replaced by logic of "top" position
		removeClass(filter, classes.fixed);
		addClass(classes.fixedBottom)(filter);
	}

	// if ( $(selectors.filter).height() + 50 < $(window).height() ) {
	//
	// }

};

const refreshFilterPosition = () => {
	if (win.innerWidth <= 1023) {
		return;
	}
	const {bottom, top, height} = content.getBoundingClientRect();
	const filterHeight = filter.getBoundingClientRect().height;

	if (height > filterHeight) {
		toggleClass(top, bottom - 150);
	} else {
		reset();
	}

};

setTimeout(function () { // fix chrome autoscroll to bottom point
	if ( $(selectors.content).size() > 0 ) {
		refreshFilterPosition();
	}
}, 1000);


const scrollListener = () => {
	win.addEventListener('scroll', refreshFilterPosition);
};

const checker = () => {
	if (win.innerWidth > 1023) {
		scrollListener();
	} else {
		reset();
		win.removeEventListener('scroll', refreshFilterPosition);
	}
};

export {
	refreshFilterPosition
};

export default () => {
	checker();
	win.addEventListener('resize', checker);
};



// WEBPACK FOOTER //
// ./app/blocks/templates/fixedFilter.js